@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.name {
  display: flex;
  align-items: center;
  margin-right: 10px;
  flex: 1;
  height: 100%;
  font-size: 18px;
  padding: 0 5px;
  .truncate();
}

.ship-together-address {
  color: @order-alerts--ship-together-address--text-color;
  font-size: 14px;
}

.badge {
  border-radius: 4px;
  background-color: @order-alerts--badge--background-color;
  color: @order-alerts--badge--text-color;
  font-size: 14px;
  margin-right: 10px;
  margin-left: 5px;
  display: flex;
  place-content: center center;
  padding: 5px;
  width: auto;
}
